import { create } from "zustand";

interface ClassActionsState {
  activeSuit: any;
  setActiveSuit: (suit: any) => void;
}

const useClassActionsStore = create<ClassActionsState>((set) => ({
  activeSuit: null,
  setActiveSuit: (suit) => set({ activeSuit: suit }),
}));

export default useClassActionsStore;
